import { Typography, type SxProps, type Theme } from '@mui/material';

export const INDEPENDENCE_NOTE =
  'O Lousa não tem vínculo com o Inep nem com o MEC. As questões são autorais, no formato do ENADE e do ENEM.';

/** Small print at the bottom of the public pages and of the app: no official link. */
export function IndependenceNote({ sx }: { sx?: SxProps<Theme> }) {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      component="p"
      sx={[
        { textAlign: 'center', maxWidth: 560, mx: 'auto', px: 2 },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {INDEPENDENCE_NOTE}
    </Typography>
  );
}
